import Vue from 'vue'

import uiPopupWindow from './src/ui-popup-window.vue';

Vue.component('ui-popup-window', uiPopupWindow);

export default uiPopupWindow;



//////////////////
// WEBPACK FOOTER
// ./~/ui-popup-window/index.js
// module id = 554
// module chunks = 0